import { axios, Response } from '../../index'

const deleteTaskModel = (taskId: string): Response<null> => {
  return axios.delete(`/v1/favorites/favorites-tasks/${taskId}`)
}

export default deleteTaskModel
